import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-d-flex p-flex-row"
}
const _hoisted_2 = { class: "kn-flex p-m-4" }
const _hoisted_3 = { class: "kn-material-input-label" }
const _hoisted_4 = { class: "p-d-flex p-flex-row kn-flex p-jc-around p-ai-center" }
const _hoisted_5 = { class: "p-mt-4" }
const _hoisted_6 = {
  key: 0,
  class: "p-d-flex p-flex-row p-m-4"
}
const _hoisted_7 = {
  class: "p-d-flex p-ai-center p-m-2",
  "data-test": "single-execution-trigger"
}
const _hoisted_8 = { class: "p-col-5" }
const _hoisted_9 = {
  for: "startDateTiming",
  class: "kn-material-input-label"
}
const _hoisted_10 = {
  key: 0,
  class: "p-error p-grid"
}
const _hoisted_11 = { class: "p-col-12" }
const _hoisted_12 = { class: "p-col-7 p-d-flex p-ai-center" }
const _hoisted_13 = {
  for: "startTime",
  class: "kn-material-input-label p-m-2"
}
const _hoisted_14 = {
  key: 0,
  class: "p-d-flex p-ai-center p-m-2",
  "data-test": "event-trigger-endDate"
}
const _hoisted_15 = { class: "p-col-5" }
const _hoisted_16 = {
  for: "endDateTiming",
  class: "kn-material-input-label"
}
const _hoisted_17 = {
  key: 0,
  class: "p-error p-grid"
}
const _hoisted_18 = { class: "p-col-12" }
const _hoisted_19 = { class: "p-col-7 p-d-flex p-ai-center" }
const _hoisted_20 = {
  for: "endTime",
  class: "kn-material-input-label p-m-2"
}
const _hoisted_21 = {
  key: 1,
  class: "p-my-4",
  "data-test": "event-trigger"
}
const _hoisted_22 = { class: "p-m-4" }
const _hoisted_23 = { class: "kn-material-input-label" }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { class: "p-d-flex p-flex-row" }
const _hoisted_26 = { class: "kn-flex p-m-4" }
const _hoisted_27 = { class: "kn-material-input-label" }
const _hoisted_28 = { class: "kn-flex p-m-4" }
const _hoisted_29 = { class: "kn-material-input-label" }
const _hoisted_30 = {
  key: 2,
  "data-test": "scheduler-trigger"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_RadioButton = _resolveComponent("RadioButton")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_Calendar = _resolveComponent("Calendar")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_KnCron = _resolveComponent("KnCron")

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.trigger)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createVNode("span", null, [
              _createVNode("label", _hoisted_3, _toDisplayString(_ctx.$t('managers.scheduler.timingDescription')) + " *", 1),
              _createVNode(_component_InputText, {
                class: ["kn-material-input p-inputtext-sm", {
                        'p-invalid': _ctx.descriptionDirty && (!_ctx.trigger.triggerDescription || _ctx.trigger.triggerDescription.length === 0)
                    }],
                modelValue: _ctx.trigger.triggerDescription,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.trigger.triggerDescription = $event)),
                maxLength: 500,
                onInput: _ctx.setTriggerName,
                onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.descriptionDirty = true))
              }, null, 8, ["modelValue", "class", "onInput"]),
              _createVNode("div", null, [
                _withDirectives(_createVNode("div", { class: "p-error p-grid p-m-2" }, _toDisplayString(_ctx.$t('common.validation.required', { fieldName: _ctx.$t('managers.scheduler.timingDescription') })), 513), [
                  [_vShow, _ctx.descriptionDirty && (!_ctx.trigger.triggerDescription || _ctx.trigger.triggerDescription.length === 0)]
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_4, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.schedulerTimingOutputTimingTabDescriptor.types, (type) => {
              return (_openBlock(), _createBlock("div", {
                key: type.value
              }, [
                _createVNode(_component_RadioButton, {
                  id: type.value,
                  name: "type",
                  value: type.value,
                  class: "p-mr-2",
                  modelValue: _ctx.triggerType,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.triggerType = $event)),
                  onChange: _ctx.formatFrequency,
                  "data-test": 'trigger-type-button-' + type.value
                }, null, 8, ["id", "value", "modelValue", "onChange", "data-test"]),
                _createVNode("label", {
                  for: type.value,
                  class: "kn-material-input-label"
                }, _toDisplayString(_ctx.$t(type.label)), 9, ["for"])
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_5, [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary" }, {
        start: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('managers.scheduler.timeWindow')), 1)
        ]),
        _: 1
      }),
      (_ctx.triggerType !== 'scheduler')
        ? (_openBlock(), _createBlock("div", _hoisted_6, [
            _createVNode("div", _hoisted_7, [
              _createVNode("div", _hoisted_8, [
                _createVNode("span", null, [
                  _createVNode("label", _hoisted_9, _toDisplayString(_ctx.$t('cron.startDate') + ':'), 1),
                  _createVNode(_component_Calendar, {
                    id: "startDateTiming",
                    class: "kn-material-input custom-timepicker",
                    style: _ctx.schedulerTimingOutputTimingTabDescriptor.style.calendarInput,
                    modelValue: _ctx.trigger.startDateTiming,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.trigger.startDateTiming = $event)),
                    showIcon: true,
                    manualInput: true,
                    onChange: _ctx.setStartDate,
                    onDateSelect: _ctx.setStartDate
                  }, null, 8, ["style", "modelValue", "onChange", "onDateSelect"])
                ]),
                (!_ctx.validDates)
                  ? (_openBlock(), _createBlock("div", _hoisted_10, [
                      _createVNode("small", _hoisted_11, _toDisplayString(_ctx.$t('managers.scheduler.dateError')), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createVNode("div", _hoisted_12, [
                _createVNode("label", _hoisted_13, _toDisplayString(_ctx.$t('cron.startTime') + ':'), 1),
                _createVNode("span", null, [
                  _createVNode(_component_Calendar, {
                    id: "startTime",
                    class: "kn-material-input custom-timepicker",
                    style: _ctx.schedulerTimingOutputTimingTabDescriptor.style.timePicker,
                    modelValue: _ctx.trigger.startTimeTiming,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.trigger.startTimeTiming = $event)),
                    showTime: true,
                    manualInput: true,
                    timeOnly: true,
                    hourFormat: "24",
                    onChange: _ctx.setStartDate,
                    onDateSelect: _ctx.setStartDate
                  }, null, 8, ["style", "modelValue", "onChange", "onDateSelect"])
                ])
              ])
            ]),
            (_ctx.triggerType === 'event')
              ? (_openBlock(), _createBlock("div", _hoisted_14, [
                  _createVNode("div", _hoisted_15, [
                    _createVNode("span", null, [
                      _createVNode("label", _hoisted_16, _toDisplayString(_ctx.$t('cron.endDate') + ':'), 1),
                      _createVNode(_component_Calendar, {
                        id: "endDateTiming",
                        class: "kn-material-input custom-timepicker",
                        style: _ctx.schedulerTimingOutputTimingTabDescriptor.style.calendarInput,
                        modelValue: _ctx.trigger.endDateTiming,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.trigger.endDateTiming = $event)),
                        showIcon: true,
                        manualInput: true,
                        onChange: _ctx.setEndDate,
                        onDateSelect: _ctx.setEndDate
                      }, null, 8, ["style", "modelValue", "onChange", "onDateSelect"])
                    ]),
                    (!_ctx.validDates)
                      ? (_openBlock(), _createBlock("div", _hoisted_17, [
                          _createVNode("small", _hoisted_18, _toDisplayString(_ctx.$t('managers.scheduler.dateError')), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode("div", _hoisted_19, [
                    _createVNode("label", _hoisted_20, _toDisplayString(_ctx.$t('cron.endTime') + ':'), 1),
                    _createVNode("span", null, [
                      _createVNode(_component_Calendar, {
                        id: "endTime",
                        class: "kn-material-input custom-timepicker",
                        style: _ctx.schedulerTimingOutputTimingTabDescriptor.style.timePicker,
                        modelValue: _ctx.trigger.endTimeTiming,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.trigger.endTimeTiming = $event)),
                        showTime: true,
                        manualInput: true,
                        timeOnly: true,
                        hourFormat: "24",
                        onChange: _ctx.setEndDate,
                        onDateSelect: _ctx.setEndDate
                      }, null, 8, ["style", "modelValue", "onChange", "onDateSelect"])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.triggerType === 'event')
        ? (_openBlock(), _createBlock("div", _hoisted_21, [
            _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary" }, {
              start: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('common.details')), 1)
              ]),
              _: 1
            }),
            _createVNode("div", _hoisted_22, [
              _createVNode("span", null, [
                _createVNode("label", _hoisted_23, _toDisplayString(_ctx.$t('managers.scheduler.eventType')), 1),
                _createVNode(_component_Dropdown, {
                  class: "kn-material-input",
                  modelValue: _ctx.trigger.chrono.parameter.type,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.trigger.chrono.parameter.type = $event)),
                  options: _ctx.eventTypes,
                  optionLabel: "label",
                  optionValue: "value"
                }, null, 8, ["modelValue", "options"])
              ])
            ]),
            (_ctx.trigger.chrono.parameter && _ctx.trigger.chrono.parameter.type === 'dataset')
              ? (_openBlock(), _createBlock("div", _hoisted_24, [
                  _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary" }, {
                    start: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('common.dataset')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode("div", _hoisted_25, [
                    _createVNode("div", _hoisted_26, [
                      _createVNode("span", null, [
                        _createVNode("label", _hoisted_27, _toDisplayString(_ctx.$t('managers.scheduler.datasetVerification')), 1),
                        _createVNode(_component_Dropdown, {
                          class: "kn-material-input",
                          modelValue: _ctx.trigger.chrono.parameter.dataset,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.trigger.chrono.parameter.dataset = $event)),
                          options: _ctx.datasets,
                          optionLabel: "label",
                          optionValue: "id.dsId",
                          filter: true,
                          filterMatchMode: "contains",
                          filterFields: ['label']
                        }, null, 8, ["modelValue", "options"])
                      ])
                    ]),
                    _createVNode("div", _hoisted_28, [
                      _createVNode("span", null, [
                        _createVNode("label", _hoisted_29, _toDisplayString(_ctx.$t('managers.scheduler.frequencyMinutes')), 1),
                        _createVNode(_component_InputText, {
                          class: "kn-material-input p-inputtext-sm",
                          type: "number",
                          modelValue: _ctx.trigger.chrono.parameter.frequency,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.trigger.chrono.parameter.frequency = $event))
                        }, null, 8, ["modelValue"])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.triggerType === 'scheduler')
        ? (_openBlock(), _createBlock("div", _hoisted_30, [
            (_ctx.trigger && _ctx.trigger.frequency)
              ? (_openBlock(), _createBlock(_component_KnCron, {
                  key: 0,
                  frequency: _ctx.trigger.frequency,
                  onCronValid: _cache[11] || (_cache[11] = ($event: any) => (_ctx.setCronValid($event)))
                }, null, 8, ["frequency"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}